export default __webpack_public_path__ + "static/media/1.dee9bb8c.jpg";